import { render, staticRenderFns } from "./MahallaIcon.vue?vue&type=template&id=4972f778"
import script from "./MahallaIcon.vue?vue&type=script&lang=js"
export * from "./MahallaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports